export default "__VITE_ASSET__CESbH8k6__"